export default __webpack_public_path__ + "static/media/container_tracking-black.94943a01.svg";